import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from "react-router-dom";

class BlogItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
          id: this.props.product.id,
          featuredImage: this.props.product.featuredImage,
          title: this.props.product.title,
          tags: this.props.product.tags,
          summary: this.props.product.summary,
          content: this.props.product.content
        };

    }

    componentWillMount() {}
    componentDidMount() {}

    render() {
        return (
          <div className="blog-home-conten-item">
             {/* <Link to={{pathname:'/BlogDetail',state:{blogId:this.props.blogId,articlesId:this.state.id}}}> */}
             <Link to={`/BlogDetail/${this.props.blogId}/${this.state.id}`}>
              <img src={this.state.featuredImage}></img>
              <div className="blog-home-conten-item-type">{this.state.tags.join(" ") }</div>
              <div className="blog-home-conten-item-text-bl">{this.state.title}</div>

              <div className="blog-home-conten-item-text-da" dangerouslySetInnerHTML={{__html:this.state.summary}}></div>
            </Link>
          </div>
        );
    }
}

function mapStateToProps(state) {
    const { helloava } = state;
    const { isAuthenticated } = helloava.auth;
    return { isAuthenticated };
}

export default withRouter(connect(mapStateToProps, null)(BlogItem));



// WEBPACK FOOTER //
// ./src/views/blog/BlogItem.js